<app-sales-credit-number [creditNumber]="data().number" [data]="data()">
</app-sales-credit-number>

<div class="container section__productPercentage h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article class="align__top">
        <div class="mainInfo">
          <h1>Veamos las condiciones</h1>
          <p>Ajusta los valores según lo que mejor se adapte a ti.</p>
        </div>

        <div class="backgroundArrow">
          <div class="arrowSvg">
            <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.5">
                <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
              </g>
              <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <!-- COTIZADOR -->
        <div class="pricingBox">
          <div class="pricingBox__data mb-10">
            <div class="pricingBox__icon">
              <img [src]="product().category?.icon_url" [alt]="product().category?.name">
            </div>

            <div class="pricingBox__title">
              <h3>{{product().name}}</h3>
            </div>
          </div>

          <div class="pricingBox__price mb-10">
            <p>
              <span>Precio:</span>
            </p>

            <div class="pricingBox__editor">
              <div class="input">
                <p-inputNumber [(ngModel)]="priceInputValue" mode="currency" [currency]="country.currency" [locale]="country.locale" [readonly]="true" [disabled]="true"></p-inputNumber>
              </div>
            </div>
          </div>

          <div class="pricingBox__actions">
            <div class="pricingBox__form mb-20">
              <div class="pricingBox__subtitle mb-10">
                <h4>Abono:</h4>
              </div>
              <div class="pricingBox__formCont">
                <div class="pricingBox__formItem percentage">
                  <label>Porcentaje</label>
                  <div class="info">
                    <p-dropdown (onChange)="onPercentageChange()" [options]="percentagesOnProduct" [(ngModel)]="selectedPercentagesOnProduct" optionLabel="label" optionValue="value" [disabled]="loading"/>
                  </div>
                </div>
                <div class="pricingBox__formSeparator">
                  <div class="icon">
                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 4L14 0V3H7V5H14V8M4 6L0 10L4 14V11H11V9H4V6Z" fill="#0046AD"/>
                    </svg>
                  </div>
                  <div class="line">
                    <span class="circle">
                      <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="4.5" cy="5.27246" r="4" stroke="#0046AD"/>
                        <circle cx="4.5" cy="5.27246" r="2.5" fill="#0046AD"/>
                      </svg>
                    </span>
                    <span class="rect"></span>
                    <span class="circle">
                      <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="4.5" cy="5.27246" r="4" stroke="#0046AD"/>
                        <circle cx="4.5" cy="5.27246" r="2.5" fill="#0046AD"/>
                      </svg>
                    </span>
                  </div>
                </div>
                <div class="pricingBox__formItem value">
                  <label>Monto</label>
                  <div class="info">
                    <p>{{ onCalculateAmount(false) | currency }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="pricingBox__frequency mb-20" *ngIf="frequency.length > 1">
              <div class="pricingBox__subtitle mb-10">
                <h4>Frecuencia de pagos:</h4>
              </div>

              <div class="pricingBox__frequencyBtns">
                <p-selectButton
                  [options]="frequency"
                  [(ngModel)]="frequencySelected"
                  optionLabel="label"
                  optionValue="value"
                  [allowEmpty]="false"
                  (onChange)="onPercentageChange()" />
              </div>
            </div>

            <div class="pricingBox__selector">
              <div class="pricingBox__subtitle mb-10">
                <h4>Opciones de plazo:</h4>
              </div>
              <div class="pricingBox__selectorCont">
                <div class="radioSelectionBox radioSelectionBox--smallP">
                  <div *ngIf="showRadioSelectionBox">
                    <div class="radioSelectionBox__item" *ngFor="let p of product().quotes; let i = index">
                      <label pRipple class="radioButtonBox" [for]="'quote' + i">
                        <p-radioButton name="quotes" [value]="p" [(ngModel)]="selectedQuote" [inputId]="'quote' + i" [disabled]="loading" />
                        <span class="radioButtonBox__text">En <strong>{{ p.quota.quantity }} cuotas</strong> y pagaré <strong>{{ p.quota.from | currency }}</strong></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <footer class="big__padBot">
        <div class="footer__content">
          <button pButton pRipple label="Continuar" (click)="saveCalculateNewPaymentInstallment()" [loading]="loading" [disabled]="!selectedQuote" class="p-button-primary p-button-raised p-button-rounded w-full"></button>
        </div>
      </footer>
    </div>
  </div>
</div>